import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=228f6d3e&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=228f6d3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f6d3e",
  null
  
)

export default component.exports